import React from "react"
import {RefTable, DefaultProps, Validator} from "../RefTable"
import {ReloadOutlined} from "@ant-design/icons";
import {updateSDRRate} from "../ExchangeRateFuncs";

export const SDRExchangeRate = (props)=><RefTable {...props}/>;

SDRExchangeRate.defaultProps = {
    ...DefaultProps,
    title: "SDR Exchange Rates",
    tableSchema: "sdr_exchange_rate",
    tableName: "sdr_exchange_rate",
    edit: true,
    actions: [
        {
            event: "sync",
            title: "Sync",
            icon: <ReloadOutlined/>
        }
    ],
    validator: {
        sdr_rate: new Validator("sdr_rate", async (value)=> {
            if(value < 0 )
                return Promise.reject("Rate cannot be negative")
        })
    },
    onEvent: async (e)=>{
        if(e === "sync")
            await updateSDRRate()
    },
}
